import { LoaderFunctionArgs } from 'react-router-dom';
import { Query } from '../../data/api';

export async function flowEntityLoader({ params }: LoaderFunctionArgs) {
  const { accountId, entityId } = params;
  if (!accountId || !entityId) throw new Error('Missing accountId or entityId');

  const query = new Query(`accounts/${accountId}/flows/${entityId}`).include(
    'health-status',
    'last-run',
    'next-run',
    'source',
    'destinations',
  );
  const data = await query.run();

  return { flow: data };
}
